import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { loadingStore } from './store'
import { storeToRefs } from 'pinia'
import { NavBar, OverlayLoading } from '@/components'
import { useUtils } from '@/composables'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = loadingStore()
const { overlayLoading: isPending } = storeToRefs(store)

const { filteredRoutes } = useUtils()
const routes = computed(() => filteredRoutes('showInDrawer'))

const drawer = ref(false)

const handleDrawer = () => {
  drawer.value = !drawer.value
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (_unref(isPending))
        ? (_openBlock(), _createBlock(_unref(OverlayLoading), {
            key: 0,
            barColor: "blue"
          }))
        : _createCommentVNode("", true),
      (!_ctx.$route.meta.hideNavBar)
        ? (_openBlock(), _createBlock(_unref(NavBar), {
            key: 1,
            onHandleDrawer: handleDrawer
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
        absolute: "",
        temporary: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            nav: "",
            dense: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), (route) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: route.uid,
                  to: { name: route.name },
                  title: route.title
                }, null, 8, ["to", "title"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "pa-0 ma-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})